import { Component, OnInit } from '@angular/core';

import { isNullOrUndefined } from 'util';
import { isNull } from '@angular/compiler/src/output/output_ast';
import { Observable } from 'rxjs';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { BehaviorSubject } from 'rxjs';
import { DataSharingService } from '../../../auth/data-sharing.service';
import { EnlistmentService } from 'src/app/services/enlistment/enlistment.service';
import { Prevendor } from 'src/app/model/prevendor.model';

import { NgForm } from '@angular/forms';
import { ElementRef, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { HttpErrorResponse } from '@angular/common/http';
import { distinctUntilChanged } from 'rxjs/operators';
import { Binary } from '@angular/compiler';
import { ReplaySubject } from 'rxjs';

@Component({
  selector: 'app-ssgmaster',
  templateUrl: './ssgmaster.component.html',
  styleUrls: ['./ssgmaster.component.css']
})
export class SsgmasterComponent implements OnInit {

  selectedSsgId: any = [];
  selectedSsgIdString: string = "";

  showSsgMaster: boolean = false;
  showEnlistmentForm: boolean = false;
  completedRegister: boolean = false;

  data: any;
  preVendor: Prevendor;

  requiredFlds: boolean = false;
  requiredCond: boolean = false;
  wrongEmail: boolean = false;
  usernameTaken : boolean = false;

  @ViewChild('submitSsgIdBtn', { static: false }) submitSsgIdBtn: ElementRef;
  @ViewChild('registerVendorBtn', { static: false }) registerVendorBtn: ElementRef;

  constructor(public router: Router, private route: ActivatedRoute, private dataSharingService: DataSharingService,
    private enlistServices: EnlistmentService) { debugger;}

  ngOnInit() {
    this.showSsgMaster = true;
    this.getSSGMasterList();
    this.preVendor = new Prevendor();
  }

  ngAfterViewInit() {
    this.submitSsgIdBtn.nativeElement.disabled = true;
  }

  getSSGMasterList() {
    this.enlistServices.getSSGMasterList().subscribe(
      data => {
        this.data = data;
        // console.log(this.data);
      }
    )
  }

  ssgCheck(ev) {

    if (ev.target.checked) {
      this.selectedSsgId.push(ev.target.defaultValue);
    }
    else {
      var index = this.selectedSsgId.indexOf(ev.target.defaultValue);
      if (index > -1) {
        this.selectedSsgId.splice(index, 1);
      }
    }

    if (this.selectedSsgId.length > 0) {
      this.submitSsgIdBtn.nativeElement.disabled = false;
    }
    else {
      this.submitSsgIdBtn.nativeElement.disabled = true;
    }

  }

  submitSsgId() {
    this.showSsgMaster = false;
    this.showEnlistmentForm = true;
    this.completedRegister = false;

    for (var i = 0; i < this.selectedSsgId.length; i++) {
      this.selectedSsgIdString = this.selectedSsgIdString + this.selectedSsgId[i];
      if (i < this.selectedSsgId.length - 1) {
        this.selectedSsgIdString = this.selectedSsgIdString + ",";
      }
    }
  }


  SubmitEnlistmentForm(form: NgForm) {

    this.requiredCond = false;
    this.requiredFlds = false;
    this.wrongEmail = false;
    this.usernameTaken = false;

    this.registerVendorBtn.nativeElement.disabled = true;

    var regexEmail = /\w+([-+.']\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*/;

    if (form.value.companyName.trim().length != 0 && form.value.address.trim().length != 0 &&
      form.value.city.trim().length != 0 && form.value.contactPersonName.trim().length != 0 &&
      form.value.email.trim().length != 0 && form.value.gstRegdAddress.trim().length != 0 &&
      form.value.gstRegdNo.trim().length != 0 && form.value.mobileNo != "" &&
      form.value.panNo.trim().length != 0 && form.value.pinCode != "" &&
      form.value.state.trim().length != 0 && form.value.country.trim().length != 0 &&
      form.value.natureOfBusiness.trim().length != 0 && form.value.ntpcOrGeApproved.trim().length != 0 &&
      form.value.executedForNtpcGe.trim().length != 0 && form.value.companyName.trim().length != 0) {

      if (regexEmail.test(form.value.email)) {
        if (form.value.cond_1_SustainableDevelop != "" && form.value.cond_2_Confiden_Agreement != ""
          && form.value.cond_3_GCC != "" && form.value.cond_4_EHS != "") {

          form.value.countryId = 1;
          form.value.sSG_Nos = this.selectedSsgIdString;
          form.value.vendorType = "ssg";

          if (form.value.natureOfBusiness == 1) {
            form.value.natureOfBusiness = "Manufacturer";
            form.value.natureOfBusinessId = 1;
          }
          else if (form.value.natureOfBusiness == 2) {
            form.value.natureOfBusiness = "Dealer (Materials Supply)";
            form.value.natureOfBusinessId = 2;
          }
          else if (form.value.natureOfBusiness == 3) {
            form.value.natureOfBusiness = "Dealer (Services)";
            form.value.natureOfBusinessId = 3;
          }
          else if (form.value.natureOfBusiness == 4) {
            form.value.natureOfBusiness = "Service Contractor";
            form.value.natureOfBusinessId = 4;
          }
          else { }

          if (form.value.ntpcOrGeApproved == 1) {
            form.value.ntpcOrGeApproved = "GE";
            form.value.ntpcOrGeApprovedId = 1;
          }
          else if (form.value.ntpcOrGeApproved == 2) {
            form.value.ntpcOrGeApproved = "NTPC";
            form.value.ntpcOrGeApprovedId = 2;
          }
          else { }

          if (form.value.executedForNtpcGe == 1) {
            form.value.executedForNtpcGe = "GE";
            form.value.executedForNtpcGeId = 1;
          }
          else if (form.value.executedForNtpcGe == 2) {
            form.value.executedForNtpcGe = "NTPC";
            form.value.executedForNtpcGeId = 2;
          }
          else { }

          this.enlistServices.registerVendorUser(form.value).subscribe(
            (data) => {
              if (data == true) {
                this.showSsgMaster = false;
                this.showEnlistmentForm = false;
                this.completedRegister = true;
              }
              else {
                //this.requiredFlds = true;
                this.usernameTaken = true;
                window.scroll(0, 0);
              }
            }
          );


        }
        else {
          this.requiredCond = true;
          window.scroll(0, 0);
        }
      }
      else {
        this.wrongEmail = true;
        window.scroll(0, 0);
      }


    }
    else {
      this.requiredFlds = true;
      window.scroll(0, 0);

    }

    this.registerVendorBtn.nativeElement.disabled = false;

  }
  Category(keyword){
    this.enlistServices.ssgcategorysearch(keyword).subscribe(
      (data)=>{
        this.data=data;
        console.log(data);
      }
    )
  }


}
